// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1Vm12","paramInput":"JobSimulator_paramInput__1e3xc","input":"JobSimulator_input__1fqTY"};